import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { EMPTY_CELL_VALUE } from '../../../NRReactGridCustomComponents/CellComponent/CellComponent';
import {
  getStatusBadgeStyles,
  getStatusBadgeVariantFromCategoryColor
} from '../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/jiraStatusBadge.utils';

function NRJiraTicketStatusBadge({ status, statusCategoryColor }) {
  const theme = useTheme();

  if (status == null || status === '') {
    return (
      <Typography variant="body2" color="text.primary">
        {EMPTY_CELL_VALUE}
      </Typography>
    );
  }

  const colors = getStatusBadgeStyles(theme, getStatusBadgeVariantFromCategoryColor(statusCategoryColor));

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        px: theme.spacing(1),
        py: theme.spacing(0.25),
        borderRadius: theme.spacing(0.5),
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.background,
        color: colors.color,
        maxWidth: '100%',
        lineHeight: 1
      }}
    >
      <Typography variant="body2" noWrap sx={{ lineHeight: 1.25 }}>
        {status}
      </Typography>
    </Box>
  );
}

export default NRJiraTicketStatusBadge;
